<template>
    <div>
        <q-table
            v-if="!add_test_screen"
            :data="tests"
            :columns="columns_tests"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            binary-state-sort
            class="q-mt-md"
            >
            <template slot="top" slot-scope="props">
                <div class="col" />
                <q-btn color="secondary" icon="fas fa-plus" :label="$t('new_f')" @click="showTest(0)" :disable="!manageWebcasts"/>
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="qty_questions" :props="props">
                    {{ props.row.qty_questions }}
                </q-td>

                <q-td auto-width key="status" :props="props">
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="fas fa-pencil-alt" @click="showTest(props.row.actions)" :disable="!manageWebcasts" >
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip') }}
                        </q-tooltip>
                    </q-btn>

                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" :disable="!manageWebcasts" >
                        <q-tooltip>
                            {{ $t('delete_tooltip') }}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <div class="row gutter-sm justify-end q-mt-lg" v-if="!add_test_screen">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="$router.push({ name: 'admin_webcasts' })" />
            </div>
        </div>

        <new-test :add_test_screen="add_test_screen" :id_webcast="id_webcast" :id_test="id_test" :test_types="test_types" :model_types="model_types" @returnToTests="returnToTests()" @changeIdTest="changeIdTest" />

        <q-dialog v-model="confirm_remove" @ok="removeTest()">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeTest()" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NewTest from 'components/admin/webcasts/ReactionTestsNewTest'
import { required, requiredIf, maxValue, minValue } from 'vuelidate/lib/validators'

export default {
    i18nOptions: { namespaces: ['custom', 'common', 'training', 'admin'] },

    props: [ 'manageWebcasts' ],

    data() {
        return {
            id_webcast: '',
            id_test: '',
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            tests: [],
            columns_tests: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: true,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'evaluation',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'qty_questions',
                    required: true,
                    label: 'questions_quantity',
                    align: 'left',
                    field: 'qty_questions',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            loading: false,
            add_test_screen: false,
            action_id: '',
            confirm_remove: false
        }
    },

    components: {
        'new-test': NewTest
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            test_types: 'registration_lists/webcast_evaluation_question_types',
            model_types: 'registration_lists/webcast_base_evaluations'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.$axios.get(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.tests = []

                response.data.forEach(result => {
                    this.tests.push({
                        id: result.id,
                        title: result.title,
                        qty_questions: result.qty_questions,
                        status: result.status,
                        actions: result.id
                    })
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        showTest(id) {
            this.id_test = id
            this.add_test_screen = true
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeTest() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_webcasts/webcasts/${this.id_webcast}/webcast_evaluations/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.notify({
                    message: this.$t('error'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle'
                })

                this.$q.loading.hide()
                console.log(e)
                this.confirm_remove = false
            })
        },

        getStatus(status) {
            if (status == 1) return 'published_f'
            else if (status == 2) return 'unpublished_f'
            else if (status == 3) return 'deleted'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },

        changeIdTest(id) {
            this.id_test = id
        },

        returnToTests() {
            window.scrollTo(0,0)

            this.request({
                pagination: this.server_pagination
            })

            this.id_test = ''
            this.add_test_screen = false
        }
    },

    created() {
        this.id_webcast = this.$route.params.id

        this.request({
            pagination: this.server_pagination
        })
    }
}
</script>

<style>

</style>
